import { makeAutoObservable } from "mobx";
import { CommonNodeO2 } from "../../Obj2Tab/Obj2Nodes";
import { allowedActions } from "../model/permissions";
import { TreeStore } from "../model/tree";
import { ProjectionContext, projectRoots } from "./projectNode";

/**
 * Дерево в том виде, в каком его ждут Ant Tree и формы.
 *
 * Геттер вычисляемый: пока его кто-то наблюдает — а в observer-компонентах это
 * так — проекция пересобирается при изменении дерева, а не на каждый рендер.
 */
export class TreeProjection {
  constructor(
    private readonly tree: TreeStore,
    private readonly ctx: ProjectionContext,
  ) {
    makeAutoObservable<TreeProjection, "ctx" | "tree">(this, {
      tree: false,
      ctx: false,
    });
  }

  get roots(): CommonNodeO2[] {
    return projectRoots(this.tree.rootIds, allowedActions, this.ctx);
  }
}
